(function () {
  var root = document.querySelector('[data-pcf]');
  if (!root || root.dataset.pcfReady) return;
  root.dataset.pcfReady = 'true';

  var form = root.querySelector('[data-pcf-form]');
  var toggle = root.querySelector('[data-pcf-toggle]');
  if (!form) return;

  if (toggle) {
    toggle.addEventListener('click', function () {
      var open = root.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  Array.prototype.forEach.call(form.querySelectorAll('[data-pcf-limit]'), function (list) {
    var limit = parseInt(list.dataset.pcfLimit, 10) || 10;
    var items = Array.prototype.slice.call(list.children);
    if (items.length <= limit) return;

    var hiddenChecked = items.slice(limit).some(function (li) {
      return li.querySelector('input:checked');
    });
    var expanded = hiddenChecked;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'pcf__more';
    list.parentNode.insertBefore(btn, list.nextSibling);

    function apply() {
      items.forEach(function (li, i) { li.hidden = !expanded && i >= limit; });
      btn.textContent = expanded ? 'Ver menos' : 'Ver mais';
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    }

    btn.addEventListener('click', function () { expanded = !expanded; apply(); });
    apply();
  });

  var timer = null;

  function submitForm() {
    var price = form.querySelector('[data-pcf-price]');
    if (price) {
      var min = form.querySelector('[data-pcf-min]');
      var max = form.querySelector('[data-pcf-max]');
      var lo = Number(price.dataset.min);
      var hi = Number(price.dataset.max);
      if (min && Number(min.value) <= lo) min.disabled = true;
      if (max && Number(max.value) >= hi) max.disabled = true;
    }
    var current = new URLSearchParams(window.location.search);
    current.forEach(function (value, key) {
      if (key.indexOf('filter.') === 0 || key === 'page') return;
      if (form.querySelector('[name="' + key + '"]')) return;
      var hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = key;
      hidden.value = value;
      form.appendChild(hidden);
    });
    form.submit();
  }

  function schedule(delay) {
    clearTimeout(timer);
    timer = setTimeout(submitForm, delay);
  }

  form.addEventListener('change', function (event) {
    var target = event.target;
    if (target.hasAttribute('data-pcf-handle')) return;
    if (target.matches('input[type="checkbox"]')) schedule(0);
    if (target.matches('input[type="range"]')) schedule(350);
  });

  var priceEl = form.querySelector('[data-pcf-price]');
  if (priceEl) {
    var minInput = priceEl.querySelector('[data-pcf-min]');
    var maxInput = priceEl.querySelector('[data-pcf-max]');
    var minOut = priceEl.querySelector('[data-pcf-min-out]');
    var maxOut = priceEl.querySelector('[data-pcf-max-out]');
    var fill = priceEl.querySelector('[data-pcf-fill]');
    var lo = Number(priceEl.dataset.min);
    var hi = Number(priceEl.dataset.max);

    function render(changed) {
      var a = Number(minInput.value);
      var b = Number(maxInput.value);
      if (a > b) {
        if (changed === 'min') { a = b; minInput.value = a; }
        else { b = a; maxInput.value = b; }
      }
      minOut.textContent = a;
      maxOut.textContent = b;
      var span = Math.max(hi - lo, 1);
      var left = ((a - lo) / span) * 100;
      var right = ((b - lo) / span) * 100;
      fill.style.left = left + '%';
      fill.style.width = Math.max(right - left, 0) + '%';
      minInput.style.zIndex = a >= hi - (hi - lo) * 0.1 ? 5 : 3;
    }

    minInput.addEventListener('input', function () { render('min'); });
    maxInput.addEventListener('input', function () { render('max'); });
    render();
  }
})();
